<template>
  <div class="m-about-content">
    <div class="m-top-box">
		<Nav/>
    </div>
	<div>
			<div class="m-bott-tab tac">
				<div class="m-tab-box">
					<span><router-link class="active" to="/solution/country/solutioncountrynumber">国资企业数字化转型</router-link></span>
				</div>
				<div class="m-tab-box">
					<span><router-link  to="/solution/country/solutioncountryoperation">数字国资互联运营平台</router-link></span>
				</div>
			</div>
		</div>
    <div>
      <div class="m-layout-center"> 
    <img style="width:100%;height:100%" src="../assets/images/cnumber1.png" alt="">
    <img style="width:100%;height:100%" src="../assets/images/cnumber2.png" alt="">
    <img style="width:100%;height:100%" src="../assets/images/cnumber3.png" alt="">
      </div>
	</div>
  </div> 
</template>
<style scoped lang="scss">
.m-top-box {
	width: 100%;
	padding-top: 10px;
	height: 660px;
	background: url(https://static.gzldyg.cn/group3/M00/06/1F/CgEyJmHzgYKACxpJAAOO9iwgJOQ158.png) no-repeat center top;
	background-size: cover;
}
.m-bott-tab {
  height: 52px;
  width: 100%;
   background-color: rgb(242, 247, 253);
//   span {
//     display: inline-block;
//     width: 140px;
//     height: 40px;
//     color: #7996ff;
//     font-size: 16px;
//   }
//   .active {
//     color: #7996ff;
//     opacity: 0.7;
//   }
  a {
    color: #000;
  }
}
.m-tab-box {
  display: inline-block;
  text-align: center;
  width: 200px;
  height: 52px;
  line-height: 52px;
  position: relative;
 .active {
    color: rgb(43, 111, 255)
  }
  span {
	text-align: center;
    // position: absolute;
    // left: 0;
    // top: 0;
  }
}
h2 {
  color: #fff;
  font-size: 68px;
  font-weight: 500;
  text-align: center;
  height: 100px;
  line-height: 100px;
  margin-top: 166px;
  margin-bottom: 84px;
}
img {
  display: inline-block;
}
.u-txt-lbl{
	display: inline-block;
	width: 100px; 
	height: 30px;
	line-height: 30px;
	font-size: 14px;
	text-align: center;
	background-color: #388CEC;
	color: #fff;
	border-radius: 4px;
}
.m-about-box1{
	width: 640px;
	height: 200px;
	background: url(../assets/images/gywm_ymt_01@2x.png) no-repeat 40px top;
	background-size: 348px 200px;
	// background-size: 560px 334px;
	padding-left: 400px;
	margin: 0 auto 25px;
}
.m-about-box2{
	width: 640px;
	height: 200px;
	background: url(../assets/images/gywm_ymt_02@2x.png) no-repeat right top;
	background-size: 336px 200px;
	padding-right: 400px;
	padding-left: 50px;
	margin: 0 auto 25px;
}
.m-about-box3{
	width: 640px;
	height: 200px;
	background: url(../assets/images/gywm_ymt_03@2x.png) no-repeat 40px top;
	background-size: 410px 200px;
	padding-left: 400px;
	margin: 0 auto 40px;
}
</style>
<script>
import Nav from "@/components/Nav.vue";
export default {
  name: "cloudcode",
  components: {
    Nav
  }
};
</script>